import React from 'react';

import CalendlyDialog from './CalendlyDialog';
import { DEFAULT_REQUEST_TRAINING_SLOT_CALENDLY_URL } from '../../lib/calendly';

export default function TrainingSlotDialog({
  open,
  onOpenChange,
  title = 'Book a Training Slot',
  description = 'Pick a training slot that works for you.',
  iframeTitle = 'Calendly training slot booking',
  src = DEFAULT_REQUEST_TRAINING_SLOT_CALENDLY_URL,
}) {
  return (
    <CalendlyDialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      iframeTitle={iframeTitle}
      src={src}
    />
  );
}
